import type { ContextGuards, Guard } from './types.js';

export function every(...guards: Guard[]) {
  return (ctx: ContextGuards) => guards.every((guard) => guard(ctx));
}
